import { useMemo } from 'react'
import { useAdmin } from '../AdminContext'
import { fetchMailSettings } from '../adminApi'
import { useLatestLoad } from '../../hooks/useLatestLoad'
import { marketingTokens } from '../marketing/marketingRules'
import { SITE_URL } from '../../data/seo'
import { withSalonFooter } from '../../core/rules/mail'
import type { NewsletterContext } from './newsletterHtml'

/**
 * Alles wat de nieuwsbrief uit de rest van het beheer leest: ontwerpen, producten, artikelen,
 * salongegevens (concept) en de huisstijl uit Mail & nieuwsbrief (zodra die geladen is).
 */
export function useNewsletterContext(): NewsletterContext {
  const { marketing, site, index, catalog } = useAdmin()
  const { data: mail } = useLatestLoad(fetchMailSettings)
  const brand = useMemo(() => (mail?.brand ? withSalonFooter(mail.brand, site.salon) : undefined), [mail?.brand, site.salon])
  return useMemo(
    () => ({
      tokens: marketingTokens(site),
      siteUrl: SITE_URL,
      salonName: site.salon.name,
      salonAddress: site.salon.address,
      design: (id) => marketing.designs.find((d) => d.id === id),
      product: (id) => index.productById(id),
      article: (slug) => catalog.articles.find((a) => a.slug === slug),
      brand,
    }),
    [marketing.designs, site, index, catalog.articles, brand],
  )
}
